import { Router, UrlTree } from '@angular/router';
import { SpecificFields } from '@clients/models/client.model';

export function getRedirectionUrl(
    roleRedirectMap: { [role: string]: string },
    authorizations: any,
    fields: SpecificFields,
    router: Router
): UrlTree {
    const role = authorizations?.role;
    if (role && roleRedirectMap[role]) {
        return router.parseUrl(roleRedirectMap[role]);
    }
    // Default behavior
    return router.parseUrl(fields?.newRecipeSearchScreenEnable ? '/recipes/search' : '/#/search');
}